export default __webpack_public_path__ + "static/media/TRADE-2.55e61da5.jpg";